'use client'

import { Spacer } from '@vinted/web-ui'

import { businessAccountFromUserDto } from '@marketplace-web/domain/business-accounts-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session'
import { useAsset } from '@marketplace-web/shared/assets'

const FormSuccess = () => {
  const translate = useTranslate('business.pro_integrations_application.success')
  const asset = useAsset()
  const businessAccountEmail = businessAccountFromUserDto(useSession().user)?.email

  return (
    <div
      className="content-block__heading u-ui-padding-vertical-x4-large@desktops u-ui-padding-vertical-x3-large@portables u-text-center u-text-right@portables pro-integrations-application_form-success"
      data-test-id="pro-integrations-application-form-success"
    >
      <img
        className="pro-integrations-application_form-success-icon"
        src={asset('check-circle.svg')}
        alt=""
      />
      <h1 className="pro-integrations-application_form-success-title">{translate('title')}</h1>
      <p className="pro-integrations-application_form-success-description">
        {translate('description', { email: businessAccountEmail })}
      </p>
      <Spacer size={Spacer.Size.XLarge} />
    </div>
  )
}

export default FormSuccess
